import React, { Component } from "react";
import { connect } from "react-redux";
import { ReactComponent as KuwaitFlag } from "./flags/kuwait.svg";
import { ReactComponent as QatarFlag } from "./flags/qatar.svg";
import { ReactComponent as UAEFlag } from "./flags/uae.svg";
import { ReactComponent as OmanFlag } from "./flags/oman.svg";
import { ReactComponent as BahrainFlag } from "./flags/bahrain.svg";
import { ReactComponent as SaudiFlag } from "./flags/sa.svg";
import CurrencyChangeModal from "./CurrencyChangeModal";
import { fetchStore, fetchBranch } from "../../store/actions";
import { ReactComponent as USAFlag } from "./flags/usa.svg";
import { ReactComponent as EURFlag } from "./flags/euro.svg";
import { ReactComponent as UKFlag } from "./flags/uk.svg";
import { UPDATE_USER } from "../../store/actions/actionTypes";
import instance from "../../store/actions/instance";

class index extends Component {
  state = {
    currencyChangeModalOpen: false,
  };

  getUserInfo = async (newCurrency) => {
    const { settings, user } = this.props;
    try {
      if (
        ((settings.enable_wallet_staff && settings.enable_wallet) ||
          (settings.enable_loyalty_points_staff &&
            settings.enable_loyalty_points)) &&
        !!user
      ) {
        this.setState({ profileLoading: true });
        const res = await instance.post("/get_user_info/", {
          country_code: newCurrency,
        });
        this.props.updateUser(res.data);
      }
    } catch (err) {}
  };
  render() {
    const { settings } = this.props;
    const { currencyChangeModalOpen } = this.state;
    if (!settings.enable_currency_converter) return <></>;
    const flagStyle = { width: 25, height: 25 };

    const flags = {
      kw: <KuwaitFlag style={flagStyle} />,
      bh: <BahrainFlag style={flagStyle} />,
      qa: <QatarFlag style={flagStyle} />,
      sa: <SaudiFlag style={flagStyle} />,
      om: <OmanFlag style={flagStyle} />,
      ae: <UAEFlag style={flagStyle} />,
      us: <USAFlag style={flagStyle} />,
      eu: <EURFlag style={flagStyle} />,
      eu: <UKFlag style={flagStyle} />,
    };

    const isos = {
      kw: "KWD",
      bh: "BHD",
      qa: "QAR",
      sa: "SAR",
      sar: "SAR",
      om: "OMR",
      ae: "AED",
      us: "USD",
      eu: "EUR",
      gp: "GBP",
      jo: "JOD",
    };

    const underlineStyle = { width: "100%", height: 4 };
    const colors = {
      kw: (
        <div
          style={{
            ...underlineStyle,
            display: "grid",
            gridTemplateColumns: "auto auto auto",
          }}
        >
          <div
            style={{ height: "100%", width: "100%", backgroundColor: "black" }}
          ></div>
          <div
            style={{ height: "100%", width: "100%", backgroundColor: "green" }}
          ></div>
          <div
            style={{ height: "100%", width: "100%", backgroundColor: "red" }}
          ></div>
        </div>
      ),
      bh: (
        <div
          style={{
            background: "#C81025",
            ...underlineStyle,
          }}
        ></div>
      ),
      qa: (
        <div
          style={{
            background: "#6C183A",
            ...underlineStyle,
          }}
        ></div>
      ),
      sa: (
        <div
          style={{
            background: "#006933",
            ...underlineStyle,
          }}
        ></div>
      ),
      om: "OMR",
      ae: (
        <div
          style={{
            ...underlineStyle,
            display: "grid",
            gridTemplateColumns: "auto auto auto",
          }}
        >
          <div
            style={{ height: "100%", width: "100%", backgroundColor: "red" }}
          ></div>
          <div
            style={{ height: "100%", width: "100%", backgroundColor: "green" }}
          ></div>
          <div
            style={{ height: "100%", width: "100%", backgroundColor: "black" }}
          ></div>
        </div>
      ),
    };
    return (
      <>
        {currencyChangeModalOpen && (
          <CurrencyChangeModal
            handleOk={(newCurrency) => {
              if (newCurrency !== this.props.currency.selected) {
                if (!this.props.branch.branch) {
                  this.props.clearStore();
                  this.props.fetchStore(
                    this.props.cart,
                    this.props.applied_promo,
                    this.props.history,
                    newCurrency
                  );
                } else {
                  this.props.clearStore();
                  this.props.fetchBranch(
                    !this.props.branch.isPickup ? "delivery" : "pickup",
                    !this.props.branch.isPickup
                      ? this.props.branch.bdc
                      : this.props.branch.branch,
                    this.props.cart,
                    this.props.applied_promo,
                    this.props.history,
                    newCurrency,
                    null,
                    this.props.branch.branch
                  );
                }
                this.getUserInfo(newCurrency);
              }
              this.setState({ currencyChangeModalOpen: false });
            }}
            handleClose={() => {
              this.setState({ currencyChangeModalOpen: false });
            }}
          />
        )}
        <div
          onClick={() => {
            if (!currencyChangeModalOpen)
              this.setState({ currencyChangeModalOpen: true });
          }}
          style={{
            height: 40,
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          {isos[this.props.currency.selected]}

          {/* <div>{colors[this.props.currency.selected]}</div> */}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currency: state.currency,
    countries: state.store.store.enabled_countries,
    settings: state.store.store.settings,
    cart: state.cart.cart,
    applied_promo: state.cart.promos,
    branch: state.branch,
    user: state.auth?.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateUser: (user) =>
      dispatch(dispatch({ type: UPDATE_USER, payload: user })),
    fetchStore: (cart, promo, history, forceCurrency) =>
      dispatch(fetchStore(cart, promo, history, forceCurrency)),
    clearStore: () => dispatch({ type: "CLEAR_STORE" }),
    fetchBranch: (
      type,
      bdc_id,
      cart,
      promo,
      history,
      forceCurrency,
      QRValid,
      branchID
    ) =>
      dispatch(
        fetchBranch(
          type,
          bdc_id,
          cart,
          promo,
          history,
          forceCurrency,
          QRValid,
          branchID
        )
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(index);
